"use strict";

var _objectSpread = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useListStyleSpecs = useListStyleSpecs;
exports.default = ListStyleSpecsProvider;
var _ramda = require("ramda");
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native");
var _defaultListStyleSpecs = _interopRequireDefault(require("../elements/defaultListStyleSpecs"));
var _SharedPropsProvider = require("./SharedPropsProvider");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}

/* eslint-disable react-native/no-inline-styles */
var listStyleSpecsContext = /*#__PURE__*/(0, _react.createContext)(_defaultListStyleSpecs.default);
function useListStyleSpecs() {
  return (0, _react.useContext)(listStyleSpecsContext);
}
function createSymbolicMarkerRenderer(_ref) {
  var Component = _ref.Component,
    counterStyleRenderer = _ref.counterStyleRenderer;
  var prefix = counterStyleRenderer.renderPrefix();
  var suffix = counterStyleRenderer.renderSuffix();
  return function (_ref2) {
    var style = _ref2.style,
      markerTextStyle = _ref2.markerTextStyle,
      counterIndex = _ref2.counterIndex,
      rtlMarkerReversed = _ref2.rtlMarkerReversed;
    return /*#__PURE__*/_react.default.createElement(_reactNative.View, {
      style: [style, {
        flexDirection: rtlMarkerReversed ? 'row-reverse' : 'row',
        justifyContent: 'flex-end'
      }]
    }, !!prefix && /*#__PURE__*/_react.default.createElement(_reactNative.Text, {
      style: markerTextStyle
    }, prefix), /*#__PURE__*/_react.default.createElement(Component, _objectSpread(_objectSpread({}, markerTextStyle), {}, {
      index: counterIndex
    })), !!suffix && /*#__PURE__*/_react.default.createElement(_reactNative.Text, {
      style: markerTextStyle
    }, suffix));
  };
}
var makeMarkerRenderers = (0, _ramda.mapObjIndexed)(function (value) {
  if (value.type === 'unitary') {
    return _objectSpread(_objectSpread({}, value), {}, {
      renderMarker: createSymbolicMarkerRenderer(value)
    });
  }
  return value;
});
function ListStyleSpecsProvider(_ref3) {
  var children = _ref3.children;
  var _ref4 = (0, _SharedPropsProvider.useSharedProps)(),
    customListStyleSpecs = _ref4.customListStyleSpecs;
  var mergedListStyleSpecs = (0, _react.useMemo)(function () {
    return makeMarkerRenderers(customListStyleSpecs != null ? _objectSpread(_objectSpread({}, _defaultListStyleSpecs.default), customListStyleSpecs) : _defaultListStyleSpecs.default);
  }, [customListStyleSpecs]);
  return /*#__PURE__*/_react.default.createElement(listStyleSpecsContext.Provider, {
    value: mergedListStyleSpecs
  }, children);
}